class FeaturedProductForm extends HTMLElement {
  constructor() {
    super();

    this.submitBtn = this.querySelector("#welcome-kit-atc");
    this.swatches = this.querySelectorAll(".single-swatch");
    this.tabs = this.querySelectorAll(".single-size-selector");
    this.subscriptionTabs = this.querySelectorAll(".single-tab-selector");
    this.accordionHeaders = this.querySelectorAll("#FeaturedProductForm .accordion-item");
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        this.setSwatch(swatch);;
      });
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        this.handleTabClick(tab);
      });
    });

    this.subscriptionTabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        this.handleSubscriptionTabClick(tab);
      });
    });

    this.accordionHeaders.forEach((accordion) => {
      accordion.addEventListener('click', (e) => {
        this.handleAccordionClick(accordion);
      });
    });

    if (this.submitBtn) {
      this.submitBtn.addEventListener("click", this.handleSubmit.bind(this));
    }

    // update item removed event
    window.addEventListener('aftersell-upcart:public-events:item-removed', this.handleItemRemoved.bind(this))
  }

  async handleSubmit() {
    const { variantId } = document.querySelector(".single-swatch.active").dataset;
    const { subscriptionId, offer } = this.submitBtn.dataset;
    let submitValid = true;

    if (this.submitBtn.dataset.bundle) {
      submitValid = await this.validateSubmit(variantId);
    }

    if (!submitValid) return;

    this.handleAddToCart(variantId, subscriptionId, offer === "true");
  }

  async validateSubmit(variantId) {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();

      const giftInCart = data.items.filter((item) => {
        return item.properties["_gwp_bundle"] == `${this.dataset.sectionId}`;
      }).length;

      if (!giftInCart) return true;
    } catch (error) {
      console.error(error);
    }

    return false;
  }

  async handleAddToCart(variantId, subscriptionId, offerValid) {
    let items = [];

    if (offerValid) {
      items = [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _welcome_kit: "true",
          },
        },
        {
          id: 43630947926238,
          quantity: 1,
        },
        {
          id: 43860529873118,
          quantity: 1,
        },
      ];
    } else {
      items = [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _gwp_bundle: `${this.dataset.sectionId}`
          },
        },
      ];
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      const data = await response.json();
      this.submitBtn.setAttribute("disabled", "true");
    } catch (error) {
      console.error("Could not add product to cart:", error);
    }
  }

  handleTabClick(tab) {
    const activeTab = this.querySelector('.single-size-selector.active');
    const { sizeSelector } = tab.dataset;

    activeTab.classList.toggle('active');
    tab.classList.toggle('active');

    this.swatches.forEach((swatch) => {
      if (swatch.dataset.tab !== sizeSelector) {
        swatch.classList.add('swatch-disabled');
      } else {
        swatch.classList.remove('swatch-disabled');
      }
    });

    const visibleSwatches = Array.from(this.swatches).filter((swatch) => !swatch.classList.contains('swatch-disabled'));

    if (visibleSwatches.length) {
      this.setSwatch(visibleSwatches[0]);
    }
  }

  setSwatch(swatch) {
    const {
      productName,
      productImage,
      tab,
      servings,
      ppsDiscounted,
      ppsNormal,
      imageA,
      imageB,
      imageC,
      imageD,
      price,
      initSubPrice,
      recurSubPrice,
      totalPrice,
      compareAt
    } = swatch.dataset;
    const swatchHolder = document.querySelector(".swatches-holder");
    const activeSwatch = swatchHolder.querySelector(".single-swatch.active");
    const flavorSelectors = this.querySelector('.flavor-selectors');
    const sizeSelectors = this.querySelectorAll('.single-size-selector');

    activeSwatch.classList.toggle("active");
    swatch.classList.toggle("active");

    sizeSelectors.forEach(size => size.classList.remove('active'));
    const activeSize = this.querySelector(`.single-size-selector[data-size-selector="${tab}"]`);
    activeSize.classList.add('active');
    activeSize.querySelector('.content-wrap .small-text').textContent = servings;

    if (tab == 'normal-jar') {
      flavorSelectors.classList.add('normal-jar-selected');
    }

    // update swatches state
    this.swatches.forEach(swatch => {
      if (swatch.dataset.tab != tab) {
        swatch.classList.add('swatch-disabled');
      } else {
        swatch.classList.remove('swatch-disabled');
      }
    });

    // update variant pricing
    this.updateElementContent('.serving-price-normal', ppsNormal);
    this.updateElementContent('.serving-price-discounted', ppsDiscounted);
    this.updateElementContent('.full-price', totalPrice);
    if (compareAt) { 
      this.updateElementContent('.compare-at', compareAt);
    } else {
      this.updateElementContent('.compare-at', '');
    }
    this.updateElementContent('.price', price);
    this.updateElementContent('.init-sub-price', initSubPrice);
    this.updateElementContent('.recur-sub-price', recurSubPrice);

    // update product name
    this.updateElementContent('.product-name', productName);

    // update product images
    this.updateImageContent(`.single-size-selector[data-size-selector="${tab}"]`, productImage);
    if (imageA) this.updateImageContent('.single-slide[data-slick-index="0"]', imageA);
    if (imageB) this.updateImageContent('.single-slide[data-slick-index="1"]', imageB);
    if (imageC) this.updateImageContent('.single-slide[data-slick-index="2"]', imageC);
    if (imageD) this.updateImageContent('.single-slide[data-slick-index="3"]', imageD);
  }

  updateElementContent(selector, content) {
    const elements = this.querySelectorAll(selector);
    elements.forEach((element) => {
      element.innerHTML = content;
    });
  }

  updateImageContent(selector, imgSrc) {
    const elements = this.querySelectorAll(selector);
    elements.forEach((element) => {
      const imgElement = element.querySelector('img');
      if (imgElement) imgElement.src = imgSrc;

      const sourceElement = element.querySelector('img');
      if (sourceElement) sourceElement.setAttribute('srcset', imgSrc);
    });
  }

  handleItemRemoved({ detail }) {
    const { item } = detail;
    if (item && item.properties['_gwp_bundle'] === this.dataset.sectionId) {
      if (this.submitBtn) this.submitBtn.removeAttribute('disabled');
    }
  }

  handleSubscriptionTabClick(tab) {
    const activeTab = this.querySelector('.single-tab-selector.active');
    const activeContent = this.querySelector('.single-tab-content.active')
    const { sub } = tab.dataset;

    if (activeTab !== tab) {
      activeTab.classList.toggle('active');
      activeContent.classList.toggle('active');
      tab.classList.toggle('active');
      this.querySelector(`.single-tab-content[data-tab-sub="${sub}"]`)?.classList.toggle('active');
    }    
  }

  handleAccordionClick(accordion) {
    const activeAccordion = this.querySelector("#FeaturedProductForm .accordion-item.active");
    if (activeAccordion) activeAccordion.classList.remove('active');

    if (accordion !== activeAccordion) {
      accordion.classList.add('active');
    }
  }
}

if (!customElements.get("featured-product-form")) {
  customElements.define("featured-product-form", FeaturedProductForm);
}
